import { render } from "./TutorialView.vue?vue&type=template&id=1bcba894&scoped=true"
import script from "./TutorialView.vue?vue&type=script&lang=js"
export * from "./TutorialView.vue?vue&type=script&lang=js"

import "./TutorialView.vue?vue&type=style&index=0&id=1bcba894&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1bcba894"]])

export default __exports__